import { Account, AccountType } from '../../graphql/generated/graphql'
import { BankAccount } from './components/BankAccounts'

const leftDigits = (str: string, count: number) => str.slice(0, count)
const rightDigits = (str: string, count: number) => str.slice(count * -1)

export const mask = (num: string) => {
    if (num.length < 6) return `•••${rightDigits(num, 2)}`
    if (num.length < 7) return `${leftDigits(num, 1)}•••${rightDigits(num, 2)}`
    if (num.length < 8) return `${leftDigits(num, 1)}•••${rightDigits(num, 3)}`
    if (num.length < 9) return `${leftDigits(num, 2)}•••${rightDigits(num, 3)}`
    if (num.length < 10) return `${leftDigits(num, 2)}••••${rightDigits(num, 3)}`
    return `${leftDigits(num, 3)}••••${rightDigits(num, 4)}`
}

export const toInitials = (name: string) => {
    const characters = name.split(' ').map((n) => n[0])
    return `${characters?.[0]?.toUpperCase() ?? ''}${
        characters?.[characters.length > 1 ? characters.length - 1 : 1]?.toUpperCase() ?? ''
    }`
}

export const toHumanReadableAccountType = (acct: BankAccount) => {
    let val

    switch (acct.type) {
        case AccountType.Business:
            val = 'Business Account'
            break
        case AccountType.Savings:
            val = 'Savings Account'
            break
        case AccountType.Checking:
            val = 'Checking Account'
            break
        default:
    }

    if (acct?.institution?.name) {
        val = acct?.institution?.name + ' | ' + val
    }

    return val
}
